import { render, staticRenderFns } from "./SwselectLaySearch.vue?vue&type=template&id=5447114a&scoped=true&"
import script from "./SwselectLaySearch.vue?vue&type=script&lang=js&"
export * from "./SwselectLaySearch.vue?vue&type=script&lang=js&"
import style0 from "./SwselectLaySearch.vue?vue&type=style&index=0&id=5447114a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5447114a",
  null
  
)

export default component.exports